import EsnafCard from '../../esnaf/EsnafCard';
import EsnafJoin from '../../esnaf/EsnafJoin';
import { useEsnaf } from '../../esnaf/esnafData';

const SHOWCASE_COUNT = 9;

/** Ana sayfa "Mahallebi Esnafı" vitrini: isletme hesabi acanlara jest + yeni esnaf cagrisi */
export default function EsnafShowcase() {
  const items = useEsnaf();
  const shown = items.slice(0, SHOWCASE_COUNT);

  return (
    <section id="esnaf" className="py-20 bg-[#f8f7f6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-4">Mahallebi Esnafı</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Mahallebi'de işletme hesabı açan komşu esnafımız. Onlar mahallende, sen de aralarında ol.
          </p>
        </div>

        {/* grid-cols-1 + min-w-0: mobilde uzun (truncate) isimler sutunu ekrandan tasirmasin */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {shown.length > 0 && (
            <div className="lg:col-span-2 min-w-0">
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
                {shown.map((item) => (
                  <EsnafCard key={item.slug} item={item} />
                ))}
              </div>
              <a
                href="/esnaf"
                className="inline-flex items-center mt-6 text-[#e77e23] font-semibold hover:text-[#d56d12] transition-colors"
              >
                Tüm esnafı gör ({items.length})
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          )}
          <div className={shown.length > 0 ? '' : 'lg:col-start-2'}>
            <EsnafJoin />
          </div>
        </div>
      </div>
    </section>
  );
}
